function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
const SvgReply = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  "data-animate": props.isAnimate || false,
  "data-interactive": props.animateOnInteraction || false
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: props.color || 'currentColor',
  strokeWidth: 2,
  d: "m1.614 6.375 4.538-3.731c.397-.327 1.023-.062 1.023.446v1.965c4.141.045 7.425.836 7.425 4.574 0 1.508-1.02 3.003-2.148 3.784-.352.244-.854-.062-.724-.457 1.169-3.561-.555-4.506-4.553-4.561v2.159c0 .508-.626.772-1.023.445L1.614 7.267a.571.571 0 0 1 0-.892Z"
}));
export default SvgReply;